import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MessageService } from 'primeng/api';
import { validTenantGuard } from '@core/multi-tenancy/valid-tenant.guard';

const routes: Routes = [
    { path: '', redirectTo: '/app/homepage', pathMatch: 'full' },
    {
        path: 'account',
        canActivate: [validTenantGuard],
        loadChildren: () => import('account/account.module').then((m) => m.AccountModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'app',
        canActivate: [validTenantGuard],
        loadChildren: () => import('app/app.module').then((m) => m.AppModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'fallback',
        loadChildren: () => import('@fallback/fallback.routes').then((m) => m.FALLBACK_ROUTES), // Lazy load fallback route
        providers: [MessageService],
        data: { preload: true },
    },
    {
        path: '**',
        redirectTo: 'fallback',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            bindToComponentInputs: true, // Enables route params to be accessed via @Input decorator in components
            scrollPositionRestoration: 'enabled', // Resets scroll on route change
        }),
    ],
    exports: [RouterModule],
    providers: [],
})
export class RootRoutingModule {}
